/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * MemberCenterIcon - Auto-generated from icon.js
 */
export const MemberCenterIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M17.4444 6H6.55556C5.69645 6 5 6.69645 5 7.55556V18.4444C5 19.3036 5.69645 20 6.55556 20H17.4444C18.3036 20 19 19.3036 19 18.4444V7.55556C19 6.69645 18.3036 6 17.4444 6Z" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M16 4V8" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M8 4V8" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M5 10H19" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export default MemberCenterIcon;
